import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RootDirective, SvgDirective } from '@pure/hive';
import { EoscFbRenderInfo } from '../../../../data/models/recommendations.models';
import { registerAsCardPlugin } from '../../services/recommendation-component-registry.service';
import { EoscRenewCallToActionComponent } from '../eosc-renewal/eosc-renew-call-to-action.component';

/** Stable registry key for this plugin. Used as the lookup name on the corresponding RenderInfo. */
export const EOSC_FB_CARD_PLUGIN_NAME = 'EoscFbCardPluginComponent';

/**
 * Plugin component for the FlashBlade end-of-support-contract (prorec-end-of-support-contract-fb)
 * card body.
 *
 * The card shell — target name, dismiss — comes from `RecommendationCardTemplateComponent`.
 * This plugin owns only the body, which matches the legacy end-of-support-contract card: the
 * icon, the expired statement, and the call to renew.
 */
@Component({
    selector: 'eosc-fb-card-plugin',
    templateUrl: './eosc-fb-card-plugin.component.html',
    styleUrls: ['./eosc-fb-card-plugin.component.scss'],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    preserveWhitespaces: false,
    imports: [EoscRenewCallToActionComponent, RootDirective, SvgDirective],
})
export class EoscFbCardPluginComponent {
    readonly renderInfo = input.required<EoscFbRenderInfo>();
}

registerAsCardPlugin(EOSC_FB_CARD_PLUGIN_NAME, EoscFbCardPluginComponent);
